import React from "react";
import {css} from "@emotion/react";

import {display, mb, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {priceFormat} from "@pg-mono/string-utils";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    actualData: IPriceReportAveragePrices | null;
    region: IRegionReportPrice;
}
export const PricesChartHeader = (props: IProps) => {
    const getAvgPrice = (type: RoomsType) => {
        if (props.actualData) {
            switch (type) {
                case RoomsType.GENERAL:
                    return priceFormat(props.actualData.avg_price_m2);
                case RoomsType.ONE_ROOM:
                    return priceFormat(props.actualData.avg_price_m2_studio);
                case RoomsType.TWO_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_2_rooms);
                case RoomsType.THREE_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_3_rooms);
                case RoomsType.FOUR_OR_MORE_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_4_plus_rooms);
                default:
                    return "-";
            }
        }
        return "-";
    };

    return (
        <div css={chartTitleStyle}>
            <div css={props.roomsType === RoomsType.GENERAL ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.GENERAL)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.GENERAL)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.ONE_ROOM ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText())} `}
                    <b>{getFlatsRoomsText(RoomsType.ONE_ROOM)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.ONE_ROOM)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.TWO_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.TWO_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.TWO_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.THREE_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.THREE_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.THREE_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.FOUR_OR_MORE_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.FOUR_OR_MORE_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.FOUR_OR_MORE_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const chartTitleStyle = css`
    ${mb(2)};
    ${p(1.5)};
    ${w100};

    ${onDesktop(css`
        ${p(0)};
    `)};
`;
import React from "react";
import {css} from "@emotion/react";

import {display, mb, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Highlight, Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {priceFormat} from "@pg-mono/string-utils";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    actualData: IPriceReportAveragePrices | null;
    region: IRegionReportPrice;
}
export const PricesChartHeader = (props: IProps) => {
    const getAvgPrice = (type: RoomsType) => {
        if (props.actualData) {
            switch (type) {
                case RoomsType.GENERAL:
                    return priceFormat(props.actualData.avg_price_m2);
                case RoomsType.ONE_ROOM:
                    return priceFormat(props.actualData.avg_price_m2_studio);
                case RoomsType.TWO_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_2_rooms);
                case RoomsType.THREE_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_3_rooms);
                case RoomsType.FOUR_OR_MORE_ROOMS:
                    return priceFormat(props.actualData.avg_price_m2_4_plus_rooms);
                default:
                    return "-";
            }
        }
        return "-";
    };

    return (
        <div css={chartTitleStyle}>
            <div css={props.roomsType === RoomsType.GENERAL ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.GENERAL)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.GENERAL)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.ONE_ROOM ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText())} `}
                    <b>{getFlatsRoomsText(RoomsType.ONE_ROOM)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.ONE_ROOM)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.TWO_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.TWO_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.TWO_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.THREE_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.THREE_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.THREE_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>

            <div css={props.roomsType === RoomsType.FOUR_OR_MORE_ROOMS ? display("block") : display("none")}>
                <Text variant="headline_4" as="h2" css={mb(1)}>
                    {`${capitalize(getAvgPricesText(props.type))} `}
                    <b>{getFlatsRoomsText(RoomsType.FOUR_OR_MORE_ROOMS)}</b>
                    {` ${props.region.name_declension_where}:`}
                </Text>
                <Text variant="headline_2" as="span">
                    <Highlight>
                        {getAvgPrice(RoomsType.FOUR_OR_MORE_ROOMS)}/m<sup>2</sup>
                    </Highlight>
                </Text>
            </div>
        </div>
    );
};

const chartTitleStyle = css`
    ${mb(2)};
    ${p(1.5)};
    ${w100};

    ${onDesktop(css`
        ${p(0)};
    `)};
`;
